import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConnectCrafterComponent } from './modules/user-umbrella/connect-crafter/connect-crafter.component';
import { UserUmbrellaComponent } from './modules/user-umbrella/user-umbrella/user-umbrella.component';
import { GlobalInterceptorInterceptor } from './shared/admin-interceptor/global-interceptor.interceptor';
import { GlobalErrorHandlerService } from './shared/error-handler/global-error-handler.service';
import { MaterialModules } from './shared/ng-material-alias/material-modules';
import { RetryInterceptor } from './shared/retry-interceptor/retry.interceptor';
import { SharedModule } from './shared/shared.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/json/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    UserUmbrellaComponent,
    ConnectCrafterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    FormsModule,
    MatTooltipModule,
    MaterialModules,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    MatProgressBarModule,
    MatTabsModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: GlobalInterceptorInterceptor, multi: true },
  { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
  { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
